import React, { useState } from "react";
import "./LearnAnyTime.css";
import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";

const LearnAnytime = () => {
    const [showModal, setShowModal] = useState(false);
  return (
    <section className="learn_anytime">
      <div className="container">
          <div className="learn_content">
        

          

        </div>
        <div className="img_holder">
          <img
            src="/assets/images/banner/learn_banner.png"
            alt="Learn Anytime"
            className="learn_img"
          />
          
          <button className="counselling_btn"   onClick={() => setShowModal(true)}>
            Get Free Counselling
          </button>
        </div>

      
      </div>
         <InquiryFormModal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </section>
  );
};

export default LearnAnytime;